// Collaborator-free reads of the passkey login JSON, and the paths the start and finish fetches use.
// callPasskeyLoginStart uses the publicKey reference and the advertised timeout.
// callPasskeyLoginFinish uses the alert reference and the UnknownCredentialOptions reference.
// Unknown keys are ignored. Nothing here calls fetch, mounts a view, or touches the DOM.

export const passkeyLoginStartApi = process.env.VUE_APP_PASSKEY_LOGIN_START_API
export const passkeyLoginFinishApi = process.env.VUE_APP_PASSKEY_LOGIN_FINISH_API

// Same publicKey reference the ceremony forwards, plus publicKey.timeout.
// A missing or null publicKey throws on the timeout read, the same as the inline access.
export function readPasskeyStart(body) {
	return {
		publicKey: body.publicKey,
		timeout: body.publicKey.timeout,
	}
}

// Same alert and UnknownCredentialOptions references. Every other key is ignored.
export function readPasskeyFinish(body) {
	return {
		alert: body.alert,
		UnknownCredentialOptions: body.UnknownCredentialOptions,
	}
}
